<template>
  <div id="teamCarTree" class="teamCarTree">
    <div class="searchArea" id="searchPanel">
      <el-input class="searchInput"  v-model="filterText"
        placeholder="车队/车辆名称" clearable size="middle" prefix-icon="el-icon-search"
      />
    </div>

<!--
       <div class="onlineBox">
      <el-radio-group v-model="onlineStatus" @change="changeStatusFilter">
        <el-radio label="0">全部({{allNum}})</el-radio>
        <el-radio label="1">在线({{onlineNum}})</el-radio>
        <el-radio label="2">离线({{offlineNum}})</el-radio>
      </el-radio-group>
    </div>

   -->


<el-tree
      class="filter-tree"
      :data="treeData.teamCarOptions"
      :props="treeData.defaultProps"
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      ref="opeTree"
      node-key="id"
      @node-click="handleNodeClick"
      :render-content="renderContent"
      :default-expand-all="treeData.defaultExpandAll"
/>
    <!--
          :default-expanded-keys="[-1]"
     highlight-current
    :render-content="renderContent"
       :render-content="renderContent"
        show-checkbox 复选框
      @check="handleNodeClick" 复选框事件
    default-expand-all 是否展开所有节点
    @node-click="handleNodeClick"点击节点，  加了show-checkbox变成选择项， @check-change选中节点-->


  </div>
</template>

<script>
import Vue from 'vue';
import {Tree} from 'element-ui'
import {teamCarTree} from "@/utils/vehiclApi";
Vue.use(Tree);


export default {
  name: "teamCarTree",
  components: {},
  data() {
    return {
      filterText: '',
      hasSearch: false,
      treeData: {
        teamCarOptions: undefined,  //车队--车辆树选项
        defaultProps: {
          children: "children",
          label: "label"
        },
        teamCarNameTree: "",
        teamCarIdTree: null,
        defaultExpandAll: true,
      }
    }
  },

  created() {
    //this.getTeamCarTree();
  },

  watch: {
    filterText(val) {
      this.$refs.opeTree.filter(val);
    }
  },


  methods: {

    /** 查询运营商--车队下拉树结构 */
    async getTeamCarTree() {
      try {
          console.log("--------getTeamCarTree-------1111----------------")
        this.treeData.teamCarOptions = [];
          console.log("--------getTeamCarTree-------1111-AAAAA---------------")
        let res = await teamCarTree();
        if (res.data.code !== 200) return this.$msg.error("获取信息失败");
        this.treeData.teamCarOptions.push(res.data.data)
          console.log("--------getTeamCarTree-------1111-ccccc--------------")
          console.log("--------getTeamCarTree------111-----[[",res.data.data,"]]--------111---------")
      } catch (error) {
      }
    },

    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 节点单击事件
    async handleNodeClick(data) {
      this.treeData.teamCarIdTree = data.id;
      this.treeData.teamCarNameTree = data.label;
      this.toTreeDataRes();
    },

    // tree添加元素
    renderContent(h, {node, data, store}) {
      return (
        <span style="margin-top:8px;margin-bottom:5px;">
              <span>
                <span title={node.label}>{node.label}</span>
              </span>
              </span>
      );
    },

    toTreeDataRes() {
      this.$emit('emitToParent', this.treeData)
    },

    hidePanel(event) {
      let pannel = document.getElementById('teamCarTree')
      if (pannel) {
        if (!pannel.contains(event.target)) {
          this.hasSearch = false
        }
      }
    },

  }

}

</script>

<style  lang='less' scoped>
.teamCarTree{
  width: 250px;
  height: 800px;
  overflow-y: scroll;
  overflow-x: scroll;
  border-right: #d3dce6 1px solid;
}

.searchArea {
  width: 100%;
  min-height: 40px;
  vertical-align: middle;
  position: relative;
}

.searchInput {
  width: 100%;
  margin: 0 auto;
  margin-top: 6px;
  margin-right: 5%
}


.filter-tree {
  width: 100%;
  height: var(--tableHeight);
  background-color:#f9fafc;
  overflow: auto;
}


/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 6px; /*对垂直流动条有效*/
  height: 6px; /*对水平流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
  /* background-color: rosybrown; */
}

/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb{
  border-radius: 8px;
  background-color: #DDDEE0;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
}

/*定义滑块悬停变化颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb:hover{
  background-color: #62b2ff; //#C7C9CC;
}

/*定义两端按钮的样式*/
::-webkit-scrollbar-button {
  background-color: #d3dce6;
}

/*定义右下角汇合处的样式*/
::-webkit-scrollbar-corner {
  background: khaki;
}


</style>
